// src/components/Footer/Footer.tsx
import React from 'react';
import './Footer.css';
import { AssetUrls } from 'config/assets';

const Footer = () => {
  const socialLinks = [
    {
      name: 'Twitter',
      url: 'https://x.com/trademagic_gg',
      icon: AssetUrls.icons.social.footer.twitter,
    },
    {
      name: 'Bluesky',
      url: 'https://bsky.app/profile/trademagic.bsky.social',
      icon: AssetUrls.icons.social.footer.bluesky,
    },
    {
      name: 'Reddit',
      url: 'https://www.reddit.com/r/TradeMagic',
      icon: AssetUrls.icons.social.footer.reddit,
    },
  ];

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-top">
          <img
            src={AssetUrls.logos.arevakhachIcon}
            alt="MagicTrade Logo"
            className="footer-logo"
          />
          <nav className="footer-nav">
            <a href="/terms">Terms of Service</a>
            <a href="/privacy">Privacy Policy</a>
            <a href="/faq">FAQ</a>
            <a href="/compare">Compare</a>
            <a href="/sets">Sets</a>
            <a href="mailto:support@trademagic.gg">
              <img
                src={AssetUrls.icons.footer.contact}
                alt="Mail Icon"
                width="14"
                height="11"
                style={{ marginRight: '6px', verticalAlign: 'middle', opacity: 0.8 }}
              />
              Contact
            </a>
            {socialLinks.map((link) => (
              <a
                key={link.name}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Visit TradeMagic on ${link.name}`}
                className="social-link"
              >
                <img
                  src={link.icon}
                  alt={`${link.name} Icon`}
                  width="25"
                  height="25"
                />
              </a>
            ))}
          </nav>
        </div>

        <div className="footer-legal" data-nosnippet>
          <p>
            Portions of <strong>TradeMagic.gg</strong> are unofficial Fan Content permitted under the Wizards of the Coast Fan Content Policy.
            The literal and graphical information presented on this site about Magic: The Gathering, including card images and mana symbols,
            is copyright Wizards of the Coast, LLC. <strong>TradeMagic.gg</strong> is not produced by or endorsed by Wizards of the Coast.
          </p>
          <p>
            Card data and pricing from <a href="https://scryfall.com" target="_blank" rel="noopener noreferrer">Scryfall</a>.
            Prices represent daily estimates and/or market values. Absolutely no guarantee is made for any price information.
          </p>
          <p className="footer-copy">
            © {new Date().getFullYear()} <strong>TradeMagic, Inc.</strong>
          </p>
        </div>
      </div>

      <img
    src={AssetUrls.icons.footer.cards}
    alt="Footer Cards Decoration"
    className="footer-decor"
  />

    </footer>
  );
};

export default Footer;
